import CommonProductCatalogue from './CommonProductCatalogue';

const PROD_TYPE_MAP = {
    "class1":"SPL","class2":"SPL","class3":"PLP","class4":"PLP",
    "class5":"PLP","class6":"PLP","class7":"PLP","class8":"PLP","class9":"PLP","class10":"PLP"
};

export default class NewINProductCatalogue extends CommonProductCatalogue{

    componentDidMount(){
        super.componentDidMount();

        this.isReloadRequired = !this.userLoggedIn;
    }

    getSelectedIndex(indVal){
        const chosenGradeFromURL = this.getProdFromQryParam();

        if(window.catalog_qry_param_support[this.getCategory()] && !isNaN(window.catalog_qry_param_support[this.getCategory()][chosenGradeFromURL])){
            return window.catalog_qry_param_support[this.getCategory()][chosenGradeFromURL];
        }

        return super.getSelectedIndex(indVal);
    }

    tabCustomCallBack(tab){
        if(tab && tab.selectedGrade){
            if(window.catalog_prod_category && window.catalog_prod_category[this.getCategory()] && window.catalog_prod_category[this.getCategory()][tab.selectedGrade]){
                this.switchProdType(window.catalog_prod_category[this.getCategory()][tab.selectedGrade]);
            }else if(PROD_TYPE_MAP[tab.selectedGrade]){
                this.switchProdType(PROD_TYPE_MAP[tab.selectedGrade]);    
            }            
        }
    }

    switchProdType(prodType){
        if(typeof this.props.switchProdType === "function"){
            this.props.switchProdType(prodType);
        }
    }

	getCategory(){
       return "IN_PLP";
    }
	
	//setting coupon false
	isCouponAllowed(){
        return (window.in_plp_discount_available);
    }

    couponAttrPrefix(){
    	return "in1";
    }

    onBillingFormClose(){
        if(this.isReloadRequired){
            window.location.reload();    
        }        
    }
}


// WEBPACK FOOTER //
// ./src/views/others/NewINProductCatalogue.js